module.exports = __webpack_public_path__ + "static/8419-images-acr1255u-j1-10f0f17715b763721bb2dfb6547915a1.png";